import React from 'react';
import { Bucket } from 'common/widgets/bucket-pane/types';
import { ButtonReact } from 'common/components/button';
import { useTranslation } from 'common/i18n/hooks';
import { ButtonTheme } from 'common/components/button/constants';
import { withStyles } from 'common/util/react';
import { NumericBucketPaneReact } from '../numeric-bucket-pane';
import styles from './index.module.styl';
import css from './index.module.styl?inline';
export type BasicBucketPaneProps = {
  header?: string;
  maxNumBuckets?: number;
  onChangeSelectedBucket: (bucket: Bucket | null) => void;
  onResetBucket: () => void;
  rangeMin?: number;
  resetBucket?: boolean;
  selectedBucket?: Bucket;
  selectedUnit?: string;
  units?: string[] | Array<{
    value: string;
    label: string;
  }>;
};
export const BasicBucketPane = withStyles((props: BasicBucketPaneProps) => {
  const {
    t
  } = useTranslation();
  const [editedBucket, setEditedBucket] = React.useState<Bucket | null>(null);
  const [validBucket, setValidBucket] = React.useState(true);
  const submitDisabled = !validBucket;
  const applyBucketSelections = () => {
    const customBucket = editedBucket !== null && editedBucket !== void 0 ? editedBucket : props.selectedBucket;
    props.onChangeSelectedBucket(customBucket !== null && customBucket !== void 0 ? customBucket : null);
  };
  const resetInterval = () => {
    props.onResetBucket();
  };
  const handleBucketUpdate = (bucket: Bucket | null, isValid: boolean) => {
    setEditedBucket(bucket);
    setValidBucket(isValid);
  };
  const handleKeyUp = (ev: React.KeyboardEvent<HTMLDivElement>) => {
    if (ev.key === "Enter" && !submitDisabled) {
      applyBucketSelections();
    }
  };
  return <div className={styles.mpBucketPane}>
      <div>
        <NumericBucketPaneReact className={styles.inputPane} units={props.units} selectedBucket={editedBucket || props.selectedBucket} selectedUnit={props.selectedUnit} maxNumBuckets={props.maxNumBuckets} rangeMin={props.rangeMin} header={props.header} onUpdate={_ref => {
        let {
          bucket,
          isValid
        } = _ref;
        return handleBucketUpdate(bucket, isValid);
      }} onKeyup={ev => handleKeyUp(ev)} useNewDesign={false} />
      </div>
      {props.resetBucket && <ButtonReact className={styles.mpBucketPaneBtn} elref='resetButton' onClick={() => resetInterval()}>
          {t("common.reset")}
        </ButtonReact>}
      <ButtonReact className={styles.mpBucketPaneBtn} disabled={submitDisabled} theme={ButtonTheme.Primary} elref='applyButton' onClick={() => applyBucketSelections()}>
        {t("common.apply")}
      </ButtonReact>
    </div>;
}, css);